export const iconButtonPalette = (tokens) => {
    return {
        border: {
            width: tokens.iconButtonBorderWidth,
            radius: {
                round: tokens.iconButtonRadiusRound,
                rectangle: tokens.iconButtonRadiusRectangle
            }
        },
        size: {
            medium: tokens.iconButtonSizeRoundM,
            input: tokens.iconButtonSizeRoundInput,
            rectangle: {
                height: tokens.iconButtonSizeRectangleDefaultHeight,
                width: tokens.iconButtonSizeRectangleDefaultWidth
            }
        },
        interactive: {
            subtle: {
                menuOpen: {
                    background: tokens.iconButtonColorBgSubtleMenuOpen,
                    border: tokens.iconButtonColorBorderSubtleMenuOpen
                },
                main: tokens.iconButtonColorBgSubtleDefault,
                background: tokens.iconButtonColorBgSubtleDefault,
                border: tokens.iconButtonColorBorderSubtleDefault,
                hover: {
                    background: tokens.iconButtonColorBgSubtleHover,
                    border: tokens.iconButtonColorBorderSubtleHover
                },
                focus: {
                    background: tokens.iconButtonColorBgSubtleFocus,
                    border: tokens.iconButtonColorBorderSubtleFocus
                },
                disabled: {
                    background: tokens.iconButtonColorBgDisabled,
                    border: tokens.iconButtonColorBorderDisabled
                },
                selected: {
                    background: tokens.iconButtonColorBgSubtleSelectedDefault,
                    border: tokens.iconButtonColorBorderSubtleSelectedDefault,
                    hover: {
                        background: tokens.iconButtonColorBgSubtleSelectedHover,
                        border: tokens.iconButtonColorBorderSubtleSelectedHover
                    }
                }
            }
        }
    };
};
export default iconButtonPalette;
//# sourceMappingURL=iconButton.js.map